import React from 'react';
import { Translate } from 'react-localize-redux';
import { DealColumn } from '../components/deal-list-column';
import DineroFactory from 'dinero.js';
import { DealName } from '../components/deal-name';

export const ADVANCE_DEAL_COLUMNS: DealColumn[] = [
  {
    key: 'deal-name',
    label: <Translate id="LABEL.DEALS.ADVANCE.ARTIST" />,
    render: (deal) => <DealName deal={deal} />,
    size: 6,
  },
  {
    key: 'deal-recouped',
    label: <Translate id="LABEL.DEALS.ADVANCE.RECOUPED" />,
    render: (deal) => (deal.recoupment || DineroFactory({amount: 0, precision: 2, currency: 'USD'})).toFormat(),
    size: 2,
    type: 'number',
  },
  {
    key: 'deal-total',
    label: <Translate id="LABEL.DEALS.ADVANCE.TOTAL" />,
    render: (deal) => deal.revenue.toFormat(),
    size: 2,
    type: 'number',
  },
];
